import Cookies from "js-cookie";
// 变量
const accessTokenKey = "accessTokenAdmin";
const refreshTokenKey = "refreshTokenAdmin";
const userAccountKey = "userAccount";
const userPasswordKey = "userPassword";

// 获取accessToken
export function getAccessToken() { return Cookies.get(accessTokenKey); }
// 写入accessToken
export function setAccessToken(value) { Cookies.set(accessTokenKey, value); }
// 删除accessToken
export function removeAccessToken() { Cookies.remove(accessTokenKey); }

// 获取refreshToken
export function getRefreshToken() { return Cookies.get(refreshTokenKey); }
// 写入refreshToken
export function setRefreshToken(value) { Cookies.set(refreshTokenKey, value); }
// 删除refreshToken
export function removeRefreshToken() { Cookies.remove(refreshTokenKey); }

// 获取userAccount
export function getUserAccount() { return Cookies.get(userAccountKey); }
// 写入userAccount
export function setUserAccount(value) { Cookies.set(userAccountKey, value); }
// 删除userAccount
export function removeUserAccount() { Cookies.remove(userAccountKey); }

// 获取userPassword
export function getUserPassword() { return Cookies.get(userPasswordKey); }
// 写入userPassword
export function setUserPassword(value) { Cookies.set(userPasswordKey, value); }
// 删除userPassword
export function removeUserPassword() { Cookies.remove(userPasswordKey); }



// WEBPACK FOOTER //
// ./src/utils/cookies.js